module.exports = __webpack_public_path__ + "d6c26df5c1637330ef87baaedb7c97e9.jpg";